












































import { Component, Mixins } from "vue-property-decorator";
import { CommonFormService } from "../../service/common-form.service";
import CommonMixin from "@/mixins/common-mixins";
import { Ready4kContent } from '@/models/content/ready4k';
import { ContentService } from "@/service/content.service"

@Component({
  components: {},
})
export default class Ready4k extends Mixins(CommonMixin) {
  commonFormService = new CommonFormService();
  contentService = new ContentService();
  content: Ready4kContent = {} as Ready4kContent;
  hrefData = "";
  commonFormLoaded = false;
  haveBadToken = false;

  async mounted(): Promise<void> {
    try {
      this.content = await this.contentService.getReady4kContent();
      const token = this.$route.params.token;
      const secure = await this.commonFormService.getReady4k(token);
      this.hrefData = `data:application/octet-stream,${secure.csv}`;
      this.commonFormLoaded = true;
    } catch (error) {
      if (error.response.status === 422) {
        this.haveBadToken = true;
      }
    }
  }
}
